// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"cover-letter_button-wrapper__8Wpo7","new-button":"cover-letter_new-button__MmIkG","loading":"cover-letter_loading__pCI5e"};